export const styles = {
  container: {
    width: '100%',
    height: 'calc(100% - 36px)',
  },
  wrapper: {
    height: '100%',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },

  content: {
    boxSizing: 'border-box',
    marginTop: '12px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    height: 'auto',
    flexWrap: 'wrap',
    gap: '16px',
    maxHeight: 'calc(100% - 60px)',
    overflowY: 'auto',
    paddingBottom: '40px !important',

    '&.in-modal': {
      padding: 0,
    },
    '&::-webkit-scrollbar': {
      width: '11px',
      height: '11px',
      padding: '5px 0',
    },
    '&::-webkit-scrollbar-track': {
      background: '#fff',
      border: 'none',
      height: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
      cursor: 'pointer',
    },
  },
};
